export default __webpack_public_path__ + "static/media/header-back.fe30cf37.jpg";